import React from "react";
import { Row, Col, Select } from "antd";
import ProductNameSearch from "./ProductNameSearch";
import { categories } from "../../constants/constants";

const { Option } = Select;

const BrowseProductSearch = ({
  searchParams,
  setSearchParams,
  setCurrentPage,
}) => {
  const handleSelectChange = (value, name) => {
    setCurrentPage(1);
    setSearchParams((prevParams) => ({
      ...prevParams,
      [name]: value,
    }));
  };

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={24} md={8}>
        <ProductNameSearch
          searchParams={searchParams}
          setSearchParams={setSearchParams}
          setCurrentPage={setCurrentPage}
        />
      </Col>
      <Col xs={24} sm={24} md={8}>
        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          <label style={{ fontWeight: 500 }}>Category:</label>
          <Select
            placeholder="Select category"
            value={searchParams.category}
            onChange={(value) => handleSelectChange(value, "category")}
            style={{ width: "100%" }}
          >
            <Option value="">All Categories</Option>
            {categories.map((category) => (
              <Option value={category.value}>{category.label}</Option>
            ))}
          </Select>
        </div>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          <label htmlFor="sortSelect" style={{ fontWeight: 500 }}>
            Sort by:
          </label>
          <Select
            placeholder="Sort by"
            value={searchParams.sortCriteria}
            onChange={(value) => handleSelectChange(value, "sortCriteria")}
            style={{ width: "100%" }}
          >
            <Option value="averageRatingdesc">Rating (High-Low)</Option>
            <Option value="averageRatingasc">Rating (Low-High)</Option>
            <Option value="priceasc">Price (Low-High)</Option>
            <Option value="pricedesc">Price (High-Low)</Option>
          </Select>
        </div>
      </Col>
    </Row>
  );
};

export default BrowseProductSearch;
